import { intervalToDuration as t } from "date-fns/intervalToDuration";
function u(o) {
  const s = t({ start: 0, end: o }), n = [];
  return s.hours && n.push(`${s.hours} hour${s.hours > 1 ? "s" : ""}`), s.minutes && n.push(`${s.minutes} minute${s.minutes > 1 ? "s" : ""}`), n.length < 2 && s.seconds && n.push(`${s.seconds} second${s.seconds > 1 ? "s" : ""}`), n.join(" and ");
}
export {
  u as formatHumanReadableTimeLeft
};
//# sourceMappingURL=timeFormat.js.map
